import { render } from "./assignmentTable.vue?vue&type=template&id=de843c7a&scoped=true"
import script from "./assignmentTable.vue?vue&type=script&lang=js"
export * from "./assignmentTable.vue?vue&type=script&lang=js"

import "./assignmentTable.vue?vue&type=style&index=0&id=de843c7a&lang=scss"
import "./assignmentTable.vue?vue&type=style&index=1&id=de843c7a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de843c7a"]])

export default __exports__